import React, { useEffect, useRef } from 'react'
function RecaptchaCheckboxInner({
  siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V2,
  onVerify,
  onExpired,
  onError,
  theme = 'light',
  size = 'normal',
  widgetIdRef = null,
}) {
  const containerRef = useRef(null)
  const internalWidgetId = useRef(null)

  useEffect(() => {
    let mounted = true

    if (!siteKey) {
      onError && onError(new Error('reCAPTCHA site key not configured'))
      return
    }

    const ensureScript = () =>
      new Promise((resolve, reject) => {
        if (window.grecaptcha && window.grecaptcha.render) return resolve()
        const existing = document.querySelector('script[src*="recaptcha/api.js"]')
        if (existing) {
          existing.addEventListener('load', () => resolve())
          existing.addEventListener('error', () => reject(new Error('recaptcha script failed to load')))
          return
        }
        const s = document.createElement('script')
        s.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
        s.async = true
        s.defer = true
        s.onload = () => resolve()
        s.onerror = () => reject(new Error('recaptcha script failed to load'))
        document.head.appendChild(s)
      })

    ensureScript()
      .then(() => {
        if (!mounted) return
        if (!window.grecaptcha || !window.grecaptcha.render) {
          onError && onError(new Error('grecaptcha not available'))
          return
        }

        try {
          const id = window.grecaptcha.render(containerRef.current, {
            sitekey: siteKey,
            theme,
            size,
            callback: token => {
              onVerify && onVerify(token)
            },
            'error-callback': () => {
              onError && onError(new Error('reCAPTCHA checkbox verification failed'))
            },
            'expired-callback': () => {
              onExpired && onExpired()
            },
          })

          internalWidgetId.current = id
          if (widgetIdRef && typeof widgetIdRef === 'object') widgetIdRef.current = id
        } catch (err) {
          onError && onError(err)
        }
      })
      .catch(err => onError && onError(err))

    return () => {
      mounted = false
      try {
        if (internalWidgetId.current != null && window.grecaptcha && window.grecaptcha.reset) {
          window.grecaptcha.reset(internalWidgetId.current)
        }
      } catch (e) {}
    }
  }, [siteKey, onVerify, onExpired, onError, theme, size, widgetIdRef])

  return <div ref={containerRef} />
}

export function RecaptchaCheckbox(props) {
  return <RecaptchaCheckboxInner {...props} />
}

export default function RecaptchaModal({
  message = 'Please complete the verification to continue',
  onVerify,
  onError,
  onClose,
  siteKey,
  theme,
  size,
}) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'rgba(0,0,0,0.5)', position: 'absolute', inset: 0 }} />
      <div style={{ zIndex: 10000, background: '#fff', padding: 20, borderRadius: 8, minWidth: 320, maxWidth: '90%' }}>
        <p style={{ marginBottom: 10 }}>{message}</p>
        <RecaptchaCheckboxInner siteKey={siteKey} theme={theme} size={size} onVerify={token => onVerify && onVerify(token)} onError={() => onError && onError()} />
        <div style={{ marginTop: 8, textAlign: 'right' }}>
          <button type="button" className="px-4 py-2 text-sm" onClick={() => onClose && onClose()}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}
